import {gql} from '@apollo/client';

// this will be used for the board columns
export const reportsQueries = {
    GET_TICKET_BAORD_USER_INFO_REPORT: gql`
        query TicketBoardUserInfoReport($boardId: UUID!, $sprintId: UUID) {
            ticketBoardUserInfoReport(boardId: $boardId, sprintId: $sprintId) {
                totalTickets
                unAssignedTickets
                userInfo {
                    userName
                    userId
                    totalAssignendTickets
                    totalEstimatedHours
                    totalHoursSpended
                    totalTrackerHours
                }
            }
        }
    `,
};
